import { render, staticRenderFns } from "./InventorySupplierValuation.vue?vue&type=template&id=482f8aaa"
import script from "./InventorySupplierValuation.vue?vue&type=script&lang=js"
export * from "./InventorySupplierValuation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports